import { render, staticRenderFns } from "./BasketProduct.vue?vue&type=template&id=29fa6042&scoped=true"
import script from "./BasketProduct.vue?vue&type=script&lang=js"
export * from "./BasketProduct.vue?vue&type=script&lang=js"
import style0 from "./BasketProduct.vue?vue&type=style&index=0&id=29fa6042&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa6042",
  null
  
)

export default component.exports